<template>
  <a-col :span="12">
    <a-form-item label="最小值">
      <a-input
        v-model:value="config.min"
        placeholder="不限制"
        allow-clear
      />
    </a-form-item>
  </a-col>
  <a-col :span="12">
    <a-form-item label="最大值">
      <a-input
        v-model:value="config.max"
        placeholder="不限制"
        allow-clear
      />
    </a-form-item>
  </a-col>
  <a-col :span="12">
    <a-form-item label="数值精度">
      <a-input
        v-model:value="config.precision"
        type="number"
      />
    </a-form-item>
  </a-col>
  <a-col :span="12">
    <a-form-item label="步进数值">
      <a-input
        v-model:value="config.step"
        type="number"
      />
    </a-form-item>
  </a-col>
</template>

<script setup lang="ts">
/* 数值范围配置（共享）：min/max/precision/step（number/money）。 */
defineProps<{ config: any }>();
</script>
